export default __webpack_public_path__ + "static/media/payment-recieved.542e2651.svg";